import ReleaseEmbedCode from './ReleaseEmbedCode';


export default ReleaseEmbedCode;
